import type { DeepRequired } from '../fixtures.types'

const verification: DeepRequired<Verification> = {
  __typename: 'Verification',
  verification_id: 'TEST_ID',
  case_id: null,
  client_id: null,
  entities: [],
  explanation: null,
  passed: null,
  failed_fields: [],
  flag: null,
  iterable_id: null,
  mortgage_id: null,
  name: null,
  optional: null,
  product_id: null,
  property_id: null,
  result_justification: null,
  scopes: [],
  auto_satisfy: null,
}

export default verification
